import React from 'react'
import moment from 'moment'
import img from '../../../../public/static/image-background/logo-v-02.png'
import locales from '../../../../public/static/locales/vi.json'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau4 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
  const { t } = useTranslation()
  const width = size
  const px = size / 100
  const color = {
    first: '#00f2fe',
    second: '#4facfe',
    text: '#ffffff',
    bg: '#0b0f19'
  }
  const classCustom = size < 1000 ? 'view' : 'export'

  return (
    <div id={id} className="bg-match-mau4" style={{ width: width, minHeight: width / 1.3, padding: `${1.6 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', backgroundColor: color.bg }}>
      <div style={{ width: `100%`, minHeight: `calc(${width / 1.3}px - ${3.2 * px}px)`, padding: `${px * 1.2}px ${px * 1.2}px ${px * 4.2}px ${px * 1.2}px`, position: 'relative', background: 'radial-gradient(circle at top left, #1a2a6c, #112 80%)', borderRadius: `${px * 2}px`, overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderBottom: `2px solid rgba(255,255,255,0.1)`, paddingBottom: `${px * 2}px` }}>
          <div style={{ flex: 1 }}>
            <Image src={dataSeason?.logo} style={{ width: `${px * 9}px`, objectFit: 'contain' }} />
          </div>
          <div style={{ flex: 6, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <h1 style={{ textAlign: 'center', color: color.first, fontSize: `${2.8 * px}px`, textTransform: 'uppercase', letterSpacing: `${px * 0.2}px`, textShadow: '0 0 10px rgba(0,242,254,0.5)' }}>{dataSeason?.name}</h1>
          </div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            <Image src={img} style={{ width: `${px * 9}px`, objectFit: 'contain' }} />
          </div>
        </div>

        {/* Title */}
        <div style={{ marginTop: `${px * 3}px`, marginBottom: `${px * 2}px` }}>
          <h1 style={{ textAlign: 'center', color: color.text, fontSize: `${4.5 * px}px`, textTransform: 'uppercase', fontWeight: 'bold' }}>{t(titleTemplate(dataSchedules[0]?.dataGo))}</h1>
          {t(numberRound) === numberRound && (
            <h1 style={{ textAlign: 'center', color: color.second, fontSize: `${2.5 * px}px`, textTransform: 'uppercase', letterSpacing: '2px', marginTop: `${px}px` }}>
              {t('round')} {numberRound}
            </h1>
          )}
          {t(numberRound) && t(numberRound) !== numberRound && (
            <h2 style={{ textTransform: 'uppercase', margin: `${px}px auto 0`, width: 'max-content', color: color.bg, backgroundColor: color.first, padding: `${0.8 * px}px ${5 * px}px`, borderRadius: `${2 * px}px`, fontSize: `${2.6 * px}px`, fontWeight: 'bold' }}>{t(numberRound)}</h2>
          )}
        </div>

        {/* Matches Grid */}
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: `${px * 2}px`, marginTop: `${px * 4}px` }}>
          {dataSchedules[0]?.dataGo
            ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
            ?.map((i, idx) => (
              <Item key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} width={width} />
            ))}
        </div>

        {/* Sponsors */}
        {isShowSponsor && sponsorData?.length > 0 && (
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: `${6 * px}px`, padding: `${2 * px}px`, background: 'rgba(255,255,255,0.05)', borderRadius: `${2 * px}px`, backdropFilter: 'blur(10px)', flexWrap: 'wrap' }}>
            {sponsorData?.slice(0, 10)?.map((i, idx) => <Image key={idx} src={i.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain', margin: `${px}px` }} />)}
          </div>
        )}

        {/* Footer */}
        <p style={{ textAlign: 'center', color: color.second, fontSize: `${2 * px}px`, position: 'absolute', bottom: `${px}px`, right: `${1.2 * px}px`, opacity: 0.8 }}>{window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}</p>
      </div>
    </div>
  )
}

const Item = React.memo(
  ({ data, px, classCustom, idx, width }) => {
    const { t } = useTranslation()
    const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
    let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
    let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

    const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

    let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
    let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

    let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
    let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

    return (
      <div style={{ width: `calc(50% - ${px}px)`, background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.02))', backdropFilter: 'blur(20px)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: `${3 * px}px`, padding: `${2 * px}px`, display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', boxShadow: '0 8px 32px 0 rgba(0,0,0,0.3)', marginBottom: `${px}px` }}>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          {/* Home Team */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Image src={data?.homeTeam?.logo} style={{ width: `${px * 7}px`, height: `${px * 7}px`, borderRadius: '50%', objectFit: 'cover', border: `2px solid #00f2fe`, boxShadow: '0 0 15px rgba(0,242,254,0.3)', backgroundColor: '#fff' }} />
            <Name propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} />
          </div>

          {/* Time/Score */}
          {data?.isCompleted ? (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: `0 ${px}px` }}>
              <div style={{ background: 'rgba(0,0,0,0.5)', padding: `${px * 0.8}px ${px * 1.5}px`, borderRadius: `${2 * px}px`, color: '#00f2fe', fontSize: `${3.6 * px}px`, letterSpacing: '1px', marginBottom: `${px}px`, minWidth: `${px * 16}px`, textAlign: 'center', whiteSpace: 'nowrap' }}>
                {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
              </div>
              <div style={{ color: '#fff', fontSize: `${1.6 * px}px`, opacity: 0.8, textTransform: 'uppercase', textAlign: 'center' }}>
                {formatDateTime(data?.dateTime, 'dateTime')}
              </div>
              {data?.hasPenalty && (
                <div style={{ color: '#fc0366', fontSize: `${1.4 * px}px`, marginTop: `${px * 0.5}px` }}>
                  (PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore})
                </div>
              )}
            </div>
          ) : (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: `0 ${px}px` }}>
              <div style={{ background: 'rgba(0,0,0,0.5)', padding: `${px * 0.8}px ${px * 1.5}px`, borderRadius: `${2 * px}px`, color: '#00f2fe', fontSize: `${2.2 * px}px`, letterSpacing: '1px', marginBottom: `${px}px`, minWidth: `${px * 10}px`, textAlign: 'center' }}>
                {formatDateTime(data?.dateTime, 'time')}
              </div>
              <div style={{ color: '#fff', fontSize: `${1.6 * px}px`, opacity: 0.8, textTransform: 'uppercase', textAlign: 'center' }}>
                {formatDateTime(data?.dateTime, 'date')}
              </div>
              {data?.stadium && (
                <div style={{ color: '#aaa', fontSize: `${1.4 * px}px`, marginTop: `${px * 0.5}px`, textAlign: 'center', maxWidth: '100%' }}>
                  📍 {data?.stadium}
                </div>
              )}
            </div>
          )}

          {/* Away Team */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Image src={data?.awayTeam?.logo} style={{ width: `${px * 7}px`, height: `${px * 7}px`, borderRadius: '50%', objectFit: 'cover', border: `2px solid #4facfe`, boxShadow: '0 0 15px rgba(79,172,254,0.3)', backgroundColor: '#fff' }} />
            <Name propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} />
          </div>
        </div>
      </div>
    )
  },
  (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

const Name = React.memo(
  ({ name, px, propClass }) => {
    const reSizeBasedOnWidth = () => {
      let fontSize = window && window?.getComputedStyle(document.querySelector(`.${propClass}`))?.fontSize
      document.querySelector(`.${propClass}`).style.fontSize = parseFloat(fontSize) - 0.2 * px + 'px'
      if (document.querySelector(`.${propClass}`).clientHeight >= document.querySelector(`.contain${propClass}`).clientHeight) {
        reSizeBasedOnWidth()
      }
    }
    const processInput = () => {
      document.querySelector(`.${propClass}`).innerHTML = name
      document.querySelector(`.${propClass}`).style.fontSize = px * 2.2 + 'px' // Default font size
      reSizeBasedOnWidth()
    }

    React.useEffect(() => {
      processInput()
    }, [name])

    return (
      <div className={`contain${propClass}`} style={{ marginTop: `${px * 1.5}px`, width: '100%', height: `${3.5 * px}px`, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
        <h2 className={propClass} style={{ color: '#ffffff', textAlign: 'center', textTransform: 'uppercase', margin: 0, fontWeight: 'bold' }}></h2>
      </div>
    )
  },
  (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

const Image = props => {
  const [data, setData] = React.useState(null)
  React.useEffect(() => {
    if (props.src) {
      getBase64(props.src).then(r => setData(r))
    }
  }, [props.src])
  return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
  return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) && JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) && JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau4, areEqual)
